require "./views/2fa_login_form_view"
{gdprCookieBanner} = require "../../cookie_banner_gdpr/frontend/main"

if $('body').hasClass 'authentication_2fa'
  $(document).ready ->
    twoFALoginFormView = new Extranet.Views.TwoFALoginFormView()
    gdprCookieBanner()
